import { MapUtils } from '../../../utility/map-utils.js';
import { DataModelBuilder, SerializationContext, SerializedData, DataModel } from '../../dto/data-model.js';
import { isSameList, isSameData } from '../../dto/data-model-utils.js';
import { FormSubmissionAnswer } from '../../../contracts/form-submission-answer.js';

export class FormSubmission extends DataModel {
  static readonly TYPE_ID: string = 'e1c7d5f6a8b0c2d4e5f7a9b1c3d6e8f0';

  constructor(
    public readonly ticketTemplateId: string | null,
    public readonly answers: FormSubmissionAnswer[],
  ) {
    super();
  }

  get $typeId(): string {
    return FormSubmission.TYPE_ID;
  }

  static create(args: {
    ticketTemplateId: string | null,
    answers: FormSubmissionAnswer[],
  }): FormSubmission {
    return new FormSubmission(args.ticketTemplateId, args.answers);
  }

  static fromMap(context: SerializationContext, map: SerializedData): FormSubmission {
    return new FormSubmission(
        MapUtils.getStringOrNull(map, 'ticketTemplateId'),
        MapUtils.getList<FormSubmissionAnswer>(map, 'answers', (e) => context.fromData<FormSubmissionAnswer>(e as SerializedData)),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'ticketTemplateId': this.ticketTemplateId,
      'answers': this.answers.map((e) => context.toData(e)),
    };
  }

  clone(): this {
    return new FormSubmission(
        this.ticketTemplateId,
        this.answers.map((e) => e.clone()),
    ) as this;
  }

  isSame(other: FormSubmission): boolean {
    if(other === this) {
      return true;
    }

    return other.ticketTemplateId === this.ticketTemplateId &&
      isSameList(other.answers, this.answers, isSameData);
  }
}

export class FormSubmissionBuilder extends DataModelBuilder<FormSubmission> {
  build(context: SerializationContext, map: SerializedData): FormSubmission {
    return FormSubmission.fromMap(context, map);
  }
}
